<template>
	<div>
		<LeadLockup lead="Billing Information" />

		<AddressForm
			:address="billingAddress"
			:errors="showFormErrors ? billingAddressErrors : []"
			:postal-code-mismatch-error="billingPostalCodeMismatchError"
			allow-international
			@change="setBillingAddress"
			@postalCodeUpdated="setBillingPostalCodeMismatchError(false)"
		>
			<EmailForm
				v-if="!isEcommerce"
				slot="email-field"
				class="address-form__item"
				:has-error="showFormErrors && hasEmailError"
			/>
		</AddressForm>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import LeadLockup from '@component/user-backend/Checkout/V4/LeadLockup.vue';
import AddressForm from '@component/user-backend/Checkout/V4/forms/AddressForm.vue';
import EmailForm from '@component/user-backend/Checkout/V4/forms/EmailForm.vue';

export default {
	components: {
		LeadLockup,
		AddressForm,
		EmailForm,
	},

	computed: {
		...mapState('checkout', [
			'billingAddress',
			'showFormErrors',
			'billingPostalCodeMismatchError',
			'isEcommerce',
		]),
		...mapGetters('checkout', ['billingAddressErrors', 'hasEmailError']),
	},

	methods: mapMutations('checkout', [
		'setBillingAddress',
		'setBillingPostalCodeMismatchError',
	]),
};
</script>
